import { getRepository } from './repository';

const resource = "/placeholder";

export default {
    getPlaceholders(headers) {
        return getRepository().get(`${resource}/list`, { headers : headers })
    },
    addPlaceholder(payload, headers) {
        return getRepository().post(`${resource}/add`, payload, {headers : headers})
    },
    updatePlaceholder(payload, headers) {
        return getRepository().post(`${resource}/update`, payload, {headers : headers})
    },
    removePlaceholder(placeholderId, headers) {
        return getRepository().post(`${resource}/remove`, {"id" : placeholderId}, {headers : headers});
    }
};